const luhn = require('fast-luhn')

const FORMAT = /^(\d{1,7})-?(\d{1})$/

module.exports = function() {
  return value => {
    if (!value || !FORMAT.test(value)) return false

    const [, digits, control] = value.match(FORMAT)

    return luhn(`${digits}${control}`)
  }
}
